import url from '../common/api'
import axios from 'axios'
import qs from 'qs'
import { setCookie, getCookie, delCookie } from '../../static/js/cookie'
var token = getCookie('user_sess')
console.log(url)
//  url.domainname + '/api/users/' + username / invite_bonus_deduction
export default {
  // 支付宝实名认证
  alipay_certify (name, idcard) {
    var params = {
      full_name: name,
      idcard
    }
    return axios({
      url: `${url.domainname}/api/users/alipay_certify`,
      method: 'POST',
      headers: {
        Authorization: token
      },
      data: params
    }).then(res => {
      return res
    })
  },
  // 查询支付宝实名认证
  certify_query (certifyId) {
    return axios({
      url: `${url.domainname}/api/users/${certifyId}/certify_query`,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 获取个人信息
  getUserInfo ({ token, username }) {
    return axios({
      url: `${url.domainname}/api/users/${username}/userinfo`,
      method: 'get',
      headers: { Authorization: token }
    })
  },
  // 提点
  invite_bonus (num) {
    var params = {
      invite_bonus: num
    }
    return axios({
      url: url.domainname + url.invite_bonus,
      method: 'post',
      headers: {
        Authorization: token
      },
      data: params
    }).then(res => {
      return res
    })
  },
  // 手机校验
  checkPhone (phone, code, type) {
    var params = {
      phone: phone,
      verification_code: code,
      type: type
    }
    return axios({
      url: url.domainname + '/api/users/verification_code',
      method: 'post',
      data: params
    }).then(res => {
      return res
    })
  },
  // 查询产品
  chaxuncp () {
    return axios({
      url: url.domainname + url.invest,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 消费记录
  xiaofeijl () {
    return axios({
      url: url.domainname + url.chargelist,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 消费记录上一页下一页
  shangxia (dangqian) {
    // 当前页
    return axios({
      url: url.domainname + url.chargelist + '?page=' + dangqian,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 查询二维码支付状态
  cxerweima (dingdh) {
    // 订单号
    return axios({
      url: url.domainname + url.checkpaystatus + dingdh,
      headers: {
        Authorization: token
      }
    }).then(res => {
      // console.log(url.domainname + url.checkpaystatus + dingdh)
      return res
    })
  },
  // 支付二维码
  erweima (zhifufs, chanpinid, leixing) {
    console.log(zhifufs, chanpinid, leixing, '微信支付方式http请求')
    // 钱数，点数，支付方式
    return axios({
      url:
        url.domainname +
        url.pay +
        'pay_type=' +
        zhifufs +
        '&product_id=' +
        chanpinid +
        '&product_type=' +
        leixing +
        '&trade_type=WAP',
      headers: {
        Authorization: token
      }
    }).then(res => {
      console.log(res)
      return res
    })
  },
  // 实名认证
  realname (name, idcard, image) {
    var params = {
      full_name: name,
      idcard: idcard,
      image: image
    }
    return axios({
      url: url.domainname + url.realname,
      method: 'POST',
      data: params,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 个人领点
  getAward (username) {
    return axios({
      url: `${url.domainname}/api/users/${username}/receive_award`,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 个人中心
  gerenzx () {
    return axios({
      url: url.domainname + url.userinfo,
      headers: {
        Authorization: token
      }
    }).then(res => {
      // console.log(res)
      return res
    })
  },
  // 个人中心
  GERENZX (payload) {
    return axios({
      url: url.domainname + url.userinfo,
      headers: {
        Authorization: payload
      }
    }).then(res => {
      console.log(url.domainname + url.userinfo)
      console.log(res)
      return res
    })
  },
  // 修改密码
  xgpass (phone, Verification, password) {
    // 手机号，手机验证码，新密码
    var params = {
      phone: phone,
      verification_code: Verification,
      password: password
    }
    return axios({
      url: url.domainname + url.reset,
      method: 'POST',
      data: params
    }).then(res => {
      return res
    })
  },

  gift_card (phone, Verification, id) {
    // 手机号，手机验证码，新密码
    var params = {
      phone: phone,
      verification_code: Verification,
      id: id * 1
    }
    return axios({
      url: url.domainname + url.gift_card,
      method: 'POST',
      headers: {
        Authorization: token
      },
      data: params
    }).then(res => {
      return res
    })
  },
  // 转账
  transfer (phone, points, remark, flag) {
    // 手机号，手机验证码，新密码
    var params = {
      phone: phone,
      points: parseInt(points),
      remark: remark,
      flag: parseInt(flag)
    }
    return axios({
      url: url.domainname + url.gift_points,
      method: 'POST',
      data: params,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 注册
  zhuce (phone, Verification, password, email, Invitation) {
    // 手机号，手机验证码，密码，邮箱，身份证号，邮箱
    var params = {
      phone: phone, // 手机号
      verification_code: Verification, // 验证码
      password: password, // 密码
      email: email, // 邮箱
      // 'full_name':name,
      // 'idcard':idCard,
      // 'image':base,
      inviter: Invitation // 邀请函
    }
    return axios({
      url: url.domainname + url.register,
      method: 'POST',
      data: params
    }).then(res => {
      console.log(url.domainname, url.register)
      return res
    })
  },
  // 绑定微信
  Bindwx (phone, Verification, password, access_token, open_id, inviter) {
    // 手机号，手机验证码，密码，
    var params = {
      phone: phone,
      verification_code: Verification,
      password: password,
      inviter: inviter,
      access_token: access_token,
      open_id: open_id,
      version: '55244'
    }
    return axios({
      url: url.domainname + url.bindwechat,
      method: 'POST',
      data: params
    }).then(res => {
      return res
    })
  },
  // 扫码发送验证码绑定微信
  scanBindwx (phone, access_token, open_id) {
    var params = {
      phone: phone,
      access_token: access_token,
      open_id: open_id,
      type: 'register',
      client: 'web'
    }
    return axios({
      url: url.domainname + url.Verification,
      method: 'POST',
      data: params
    }).then(res => {
      return res
    })
  },
  // 短信登录
  dxdenglu (phone, Verification) {
    // 手机号，验证码
    var parama = {
      username: phone,
      password: Verification,
      version: 'Browser'
    }
    return axios({
      url: url.domainname + url.dxSignin,
      method: 'POST',
      data: qs.stringify(parama)
    }).then(res => {
      return res
    })
  },
  // 登录接口
  denglu (phone, password) {
    // 手机号，密码
    var params = {
      username: phone,
      password: password,
      version: 'Browser'
    }
    return axios({
      url: url.domainname + url.Signin,
      method: 'POST',
      data: qs.stringify(params)
    }).then(res => {
      return res
    })
  },
  // 登录接口
  wxdenglu () {
    // 手机号，密码
    return axios({
      url: url.domainname + url.Signin + '?type=wechat&version=Browser&app=web',
      method: 'GET'
    }).then(res => {
      return res
    })
  },
  // 发送验证码
  send (phone, nc_token, session_id, captcha_sign, typeWX) {
    // 手机号
    var params = {
      phone: phone,
      nc_token: nc_token,
      scene: 'nc_other',
      session_id: session_id,
      captcha_sign: captcha_sign,
      type: typeWX
    }
    console.log(params)
    return axios({
      url: url.domainname + url.Verification,
      method: 'post',
      data: params
    }).then(res => {
      console.log(res, url)
      return res
    })
  },
  // 注销发送验证码
  logoutVerification (phone, type) {
    let params = {
      phone
    }
    return axios({
      url: url.domainname + url.Verification,
      method: 'post',
      data: params
    }).then(res => {
      console.log(res)
      return res
    })
  },
  // 确认注销账户
  httpLogoutConfirmLogout (phonecode) {
    let params = {
      verification_code: phonecode
    }
    return axios({
      url: `${url.domainname}/api/users/close_account`,
      method: 'POST',
      data: params,
      headers: {
        authorization: token
      }
    }).then(res => {
      console.log(res)
      return res
    })
  },
  // 邀请码失去焦点
  yzyaoqingma (Invitation) {
    // 邀请码
    return axios({
      url: url.domainname + url.Invitationq + Invitation + url.Invitationh
    }).then(res => {
      return res
    })
  },
  // 邮箱失去焦点
  yzemail (email) {
    // 邮箱
    return axios({
      url: url.domainname + url.emailq + email + url.emailh
    }).then(res => {
      return res
    })
  },
  // 手机号失去焦点
  yzpho (phone) {
    // 手机号
    return axios({
      url: url.domainname + url.phoneq + phone + url.phoneh
    }).then(res => {
      // console.log(res,123123123)
      // console.log(url.domainname)
      // console.log(url.phoneq)
      // console.log(phone)
      // console.log(url.phoneh)/////
      return res
    })
  },
  // 身份证号失去焦点
  yzidcard (carda) {
    // 身份证号
    return axios({
      url: `${url.domainname}/api/users/${carda}/idcard_exist`
    }).then(res => {
      return res
    })
  },
  // 文章
  wenzhang (id) {
    // 文章的id   旧
    return axios({
      url: url.domainname + url.fufeiwenzhangq + id + url.fuweiwenzhangh,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  fuweiwenzhang (qian, dian, id) {
    // 钱数，点数，文章id    旧
    return axios({
      url:
        url.domainname +
        url.payone +
        qian +
        url.paytwo +
        dian +
        '&paytype=alipay&articleid=' +
        id,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 查找文章
  chawz (leixing) {
    // 类型  新
    return axios({
      url: url.domainname + url.chawzq + leixing + url.chawzh
    }).then(res => {
      return res
    })
  },
  // 带分页的文章（用户 展示使用）
  queryNews (params) {
    return axios({
      url: `${url.domainname}/api/article/${params.type}/typelimit?page=${params.page}`
    }).then(res => {
      return res
    })
  },
  // 文章 公告 运营页面使用
  queryManageNews (params) {
    return axios({
      url: `${url.domainname}/api/article/${params.type}/typelimit?page=${params.page}&active=${'all'}`
    }).then(res => {
      return res
    })
  },
  // 新增文章
  addNews (params) {
    return axios({
      url: `${url.domainname}/api/article`,
      method: 'POST',
      headers: {
        Authorization: token
      },
      data: params
    }).then(res => {
      return res
    })
  },
  // 修改文章
  upNews (params) {
    return axios({
      url: `${url.domainname}/api/article`,
      method: 'PATCH',
      headers: {
        Authorization: token
      },
      data: params
    }).then(res => {

    })
  },
  // 查找文章
  chawzid (id) {
    // id  新
    return axios({
      url: url.domainname + url.chawzidq + id + url.chawzidh
    }).then(res => {
      return res
    })
  },
  // 查询版本
  chabb () {
    return axios({
      url: url.domainname + url.banben
    }).then(res => {
      return res
    })
  },
  // 查询产品
  chaxuncp () {
    return axios({
      url: url.domainname + url.invest,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 查询周卡产品
  cxzkouka () {
    return axios({
      url: url.domainname + url.ckzhouk,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  CXZKOUKA (payload) {
    return axios({
      url: url.domainname + url.ckzhouk,
      headers: {
        Authorization: payload
      }
    }).then(res => {
      return res
    })
  },
  // 查询用户购买周卡产品
  payzhouk () {
    return axios({
      url: url.domainname + url.payzk,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 激活周卡
  jhzhouka (id) {
    return axios({
      url: url.domainname + url.jihuozkq + id + url.jihuozkh,
      method: 'PATCH',
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 客户端下载链接获取   type:  安卓 1,mac 2, pc 3, 安卓电视版:4
  getLink (type) {
    return axios({
      url: `${url.domainname}${url.Downloadlink}?type=${type}`
    }).then(res => {
      return res
    })
  },

  // 充值记录
  chongzhijl (type) {
    return axios({
      url: url.domainname + url.orderlist + '?type=' + type,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 充值记录上一页下一页
  sxye (dangqian, type) {
    // 当前页
    return axios({
      url:
        url.domainname + url.orderlist + '?page=' + dangqian + '&type=' + type,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  /*
    Yang
  */
  // 查询充值历史
  CZRechargehistory (dangqianye) {
    return axios({
      url: url.domainname + url.orderlist + '?page=' + dangqianye,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },
  // 计时卡充值记录
  Timecardrechargerecord () {
    return axios({
      url: url.domainname + url.payzk,
      headers: {
        Authorization: token
      }
    }).then(res => {
      return res
    })
  },

  // 注册海星云个人账户
  hxy_registered (phone, password, Verification, Invitation, ticket, randstr) {
    var parame = {
      phone: phone,
      password: password,
      verification_code: Verification,
      inviter: Invitation,
      ticket: ticket,
      randstr: randstr
    }
    return axios({
      url: url.domainname + url.register,
      method: 'POST',
      data: parame
    }).then(res => {
      return res
    })
  },

  // 发送验证码
  SMSverification (phone, type) {
    var parame = {
      phone: phone,
      type: type
    }
    return axios({
      url: url.domainname + '/api/users/phone_auth',
      method: 'post',
      data: parame
    })
      .then(res => {
        // console.log(res,"在官网使用手机号请求注册账户")
        return res
      })
  },

  // 提现记录
  CashBack_history (username, page) {
    return axios({
      url: url.domainname + url.register + '/' + username + '/invite_bonus_deduction' + '?' + `page=${page}`,
      headers: {
        Authorization: token
      },
      method: 'get'
    }).then(res => {
      return res
    })
  },

  // 返现记录
  withdraw_history (username, page) {
    return axios({
      url: url.domainname + url.register + '/' + username + '/orderlist' + '?' + `page=${page}&type=4`,
      headers: {
        Authorization: token
      },
      method: 'get'
    }).then(res => {
      return res
    })
  },
  postWithdrawal (bank_info, bank_account, amount) {
    return axios({
      url: url.domainname + url.withdrawal,
      headers: {
        Authorization: token
      },
      data: {
        'bank_info': bank_info,
        'bank_account': bank_account,
        'amount': parseInt(amount)
      },
      method: 'post'
    }).then(res => {
      return res
    })
  },
  getWithdrawals (page = 1) {
    return axios({
      url: url.domainname + url.withdrawal + '/all?page=' + page,
      headers: {
        Authorization: token
      },
      method: 'get'
    }).then(res => {
      return res
    })
  },
  cancelPostWithdrawal (id) {
    return axios({
      url: url.domainname + url.withdrawal + '/cancel',
      headers: {
        Authorization: token
      },
      params: {
        'id': id
      },
      method: 'get'
    }).then(res => {
      return res
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/http.js